export const shouldForwardProp = (prop: string) => prop.at(0) !== "$"
